import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, map, take } from 'rxjs/operators';
import { AbstractControlDirective } from '@supoui/shared/components/abstract-control.directive';
import { CountryDetails } from '@supoui/shared/model/country';
import { AutoCompleteTypeEnum } from '@supoui/shared/components/input-country/auto-complete-type-enum';
import { NgSelectComponent } from '@ng-select/ng-select';
import { PublicMasterListService } from '@supoui/core/services/public-master-list.service';
import { UntilDestroy } from '@ngneat/until-destroy';

@Component({
    selector: 'app-input-country',
    templateUrl: './input-country.component.html',
    styleUrls: ['./input-country.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            useExisting: forwardRef(() => InputCountryComponent),
            multi: true
        }
    ],
    standalone: false
})
@UntilDestroy({ checkProperties: true })
export class InputCountryComponent extends AbstractControlDirective implements OnInit {
  public countryControl: UntypedFormControl = new UntypedFormControl();

  @ViewChild('select') select: NgSelectComponent;

  @Input() showPhonePrefix: boolean;
  @Input() autoCompleteTypeEnum: AutoCompleteTypeEnum;
  @Input() name: string;
  @Input() selectedItemId: string;
  @Input() disabled: boolean;
  @Input() required: boolean;
  @Input() showCode: boolean;
  @Input() withInput: boolean;
  @Input() countryName: string;

  @Output() selectedItemRemoved = new EventEmitter();
  @Output() saveModel = new EventEmitter();
  @Output() change = new EventEmitter<CountryDetails>();

  items: CountryDetails[];
  input = new Subject<string | null>();

  constructor(private publicMasterListService: PublicMasterListService) {
    super();
    this.subscriptions.push(
      this.countryControl.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.input.subscribe(newTerm => {
        if (newTerm && newTerm.length > 1) {
          this.search(newTerm);
        }
      })
    );
  }

  public writeValue(value: string | null): void {
    value = value === undefined ? null : value;
    this.countryControl.patchValue(value, { emitEvent: false });
  }

  public setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.countryControl.disable({ emitEvent: false });
    } else {
      this.countryControl.enable({ emitEvent: false });
    }
  }

  changeCountry(country: CountryDetails): void {
    this.change.emit(country);
  }

  private search(term: string): void {
    this.publicMasterListService
      .searchCountries(term)
      .pipe(
        debounceTime(200),
        map(result => (this.items = result)),
        take(1)
      )
      .subscribe();
  }
}
